module.exports = __webpack_public_path__ + "static/img/5.a2b91ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/zh/5.png
// module id = I8si
// module chunks = 0